function refIsObject(ref) {
  var _ref;
  return (_ref = ref && typeof ref !== 'function') !== null && _ref !== void 0 ? _ref : false;
}

export { refIsObject as default };
//# sourceMappingURL=refIsObject.js.map
